import { CalendarIcon } from "@phosphor-icons/react/dist/csr/Calendar";
import { CurrencyDollarIcon } from "@phosphor-icons/react/dist/csr/CurrencyDollar";
import { HashIcon } from "@phosphor-icons/react/dist/csr/Hash";
import { PercentIcon } from "@phosphor-icons/react/dist/csr/Percent";
import { TextTIcon } from "@phosphor-icons/react/dist/csr/TextT";
import type { ReactNode } from "react";
import {
  AI_SPREADSHEET_VALUE_TYPE,
  type AiSpreadsheetValueType,
} from "@/payroll/ai-script/types";

interface CellFormatOption {
  value: AiSpreadsheetValueType;
  label: string;
  icon: ReactNode;
}

export const CELL_FORMAT_OPTIONS: CellFormatOption[] = [
  {
    value: AI_SPREADSHEET_VALUE_TYPE.currency,
    label: "Currency",
    icon: <CurrencyDollarIcon className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.percent,
    label: "Percent",
    icon: <PercentIcon className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.number,
    label: "Number",
    icon: <HashIcon className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.text,
    label: "Text",
    icon: <TextTIcon className="h-3.5 w-3.5" />,
  },
  {
    value: AI_SPREADSHEET_VALUE_TYPE.date,
    label: "Date",
    icon: <CalendarIcon className="h-3.5 w-3.5" />,
  },
];
